import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    common: {
      white: '#ffffff',
      black: '#000000',
    },
    background: {
      default: '#FEFCFA',
      paper: '#EBE8E5',
    },
  },
  typography: {
    allVariants: {
      color: '#ffffff',
    },
  },
});
